import React, { useEffect } from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import CustomButton from "../../../Components/Atoms/CustomButton";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  postEmployeeRequest,
  postEmployeeResponseClear,
  putEmployeeRequest,
  putEmployeeResponseClear,
} from "../../../Redux/Employees/EmployeesActions";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { COMPONENTS, expression, role } from "../../../Constant";
import { getCountryListRequest } from "../../../Redux/CountryState/Country/CountryActions";
import { getStateListRequest } from "../../../Redux/CountryState/State/StateActions";
import { getCustomRoleListRequest } from "../../../Redux/Settings/SettingsActions";
import MaskingComponent from "../../../Components/Atoms/MaskingComponent/Index";
import CustomCheckBox from "../../../Components/Atoms/CustomCheckbox";
import { isSuperAdmin } from "../../../Utils/getters";
const INDIAN_MOBILE_REGEX = /^(\+?91|0)?[6789]\d{9}$/;

const AddEmployees = ({ handleClose, employeeData }) => {
  const dispatch = useDispatch();

  const { StatListResponse } = useSelector((state) => state.state);
  const { CountryListResponse } = useSelector((state) => state.country);
  const { getUserResponse } = useSelector((state) => state.user);

  const validationArray = Yup.object({
    first_name: Yup.string()
      .required("Required")
      .min(3, "Minimum of 3 characters")
      .max(30, "Maximum of 30 characters"),
    phone_number: Yup.string().required("Required"),
    rank: Yup.string().required("Required"),
    // id_type: Yup.string().required("Required"),
    // nric: Yup.string().when(["$id_type"], ([id_type], schema) => {
    //   if (id_type === "NRIC") {
    //     return Yup.string()
    //       .required("Required")
    //       .matches(expression.nric_regex, expression.nric_message);
    //   }
    //   return schema;
    // }),

    // fin: Yup.string().when(["$id_type"], ([id_type], schema) => {
    //   if (id_type === "FIN") {
    //     return Yup.string()
    //       .required("Required")
    //       .matches(expression.fin_regex, expression.fin_message);
    //   }
    //   return schema;
    // }),

    // passport: Yup.string().when(["$id_type"], ([id_type], schema) => {
    //   if (id_type === "PASSPORT") {
    //     return Yup.string().required("Required");
    //   }
    //   return schema;
    // }),
    email: Yup.string().email().required("Required"),
    role: Yup.string().required("Required"),
    address_detail: Yup.object().shape({
      address: Yup.string()
        .required("Required")
        .min(3, "Minimum of 3 characters")
        .max(200, "Maximum of 200 characters"),
      city: Yup.string()
        .min(3, "Minimum of 3 characters")
        .max(30, "Maximum of 30 characters")
        .matches(expression.min_one_char, "City should have a character")
        .matches(expression.space, "City should not contain spaces"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      first_name: "",
      email: "",
      phone_number: "",
      role: "",
      rank: "",
      // designation: "",
      // id_type: "NRIC", //NRIC,FIN and PASSPORT
      // nric_masking: "",
      // nric: "",
      // nric_char: "",
      // fin_masking: "",
      // fin: "",
      // fin_char: "",
      // passport: "",
      is_super_admin: false,
      otp_feature: false,
      address_detail: {
        address: "",
        country: "",
        state: "",
        city: "",
        zipcode: "",
      },
    },
    validationSchema: validationArray,
    onSubmit: (values) => {
      if (employeeData) {
        dispatch(putEmployeeRequest({ ...values, id: employeeData._id }));
      } else {
        dispatch(postEmployeeRequest(values));
      }
      handleClose();
    },
  });

  const { getCustomRoleListResponse } = useSelector(
    (state) => state.settingsReducer,
  );

  useEffect(() => {
    dispatch(getCountryListRequest());
    dispatch(
      getCustomRoleListRequest({
        filters: {
          search: {
            value: "",
          },
        },
        limit: "",
        page: "",
        sort: "name:asc",
      }),
    );
  }, []);

  useEffect(() => {
    if (formik.values.address_detail.country) {
      dispatch(getStateListRequest(formik.values.address_detail.country));
    }
  }, [formik.values.address_detail?.country]);

  useEffect(() => {
    if (employeeData) {
      formik.setFieldValue("first_name", employeeData?.first_name);
      formik.setFieldValue("rank", employeeData?.rank);
      formik.setFieldValue("otp_feature", employeeData?.otp_feature);
      formik.setFieldValue("is_super_admin", employeeData?.is_super_admin);
      formik.setFieldValue("designation", employeeData?.designation);
      formik.setFieldValue("email", employeeData?.email);
      formik.setFieldValue("phone_number", employeeData?.phone_number);
      formik.setFieldValue(
        "address_detail.state",
        employeeData.address_detail?.state,
      );
      formik.setFieldValue(
        "address_detail.country",
        employeeData.address_detail?.country,
      );
      formik.setFieldValue(
        "address_detail.address",
        employeeData.address_detail?.address,
      );
      formik.setFieldValue(
        "address_detail.city",
        employeeData?.address_detail?.city,
      );
      formik.setFieldValue(
        "address_detail.zipcode",
        employeeData?.address_detail?.zipcode,
      );
      formik.setFieldValue("role", employeeData?.role?._id || "");
      // formik.setFieldValue("passport", employeeData?.passport || "");
      // formik.setFieldValue("nric_masking", employeeData?.nric_masking || "");
      // formik.setFieldValue("nric", employeeData?.nric || "");
      // formik.setFieldValue("fin", employeeData?.fin || "");
      // formik.setFieldValue("fin_masking", employeeData?.fin_masking || "");
      // formik.setFieldValue("id_type", employeeData?.id_type || "");
    } else {
      formik.resetForm();
    }
  }, [employeeData]);

  return (
    <>
      <div className="">
        <form onSubmit={formik.handleSubmit} autoComplete="off">
          <div className="cntr mb-3">
            <h6>{"PRIMARY DETAILS"}</h6>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex">
                <p className="mb-1">User Name</p>
                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="text"
                name="first_name"
                placeholder="Enter user name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.first_name}
                formik={formik}
              />
            </div>
            <div className="col-md-4">
              <div className="d-flex">
                <p className="mb-1">Phone Number</p>

                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="number"
                name="phone_number"
                placeholder="Enter phone number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone_number}
                formik={formik}
              />
            </div>{" "}
            <div className="col-md-4">
              <div className="d-flex">
                <p className="mb-1">Email</p>
                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="text"
                component={COMPONENTS.EMAIL}
                name="email"
                placeholder="Enter email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                formik={formik}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="d-flex">
                <p className="mb-1">Rank</p>

                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="text"
                name="rank"
                placeholder="Enter rank"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.rank}
                formik={formik}
              />
            </div>{" "}
            {/* <div className="col-md-4">
              <div className="d-flex">
                <p className="mb-1">ID Type</p>
                <p className="erroStar">*</p>
              </div>
              <CustomSelect
                type="text"
                name="id_type"
                placeholder="Select ID Type"
                onChange={(e) => {
                  formik.handleChange(e);
                  formik.setFieldValue("nric_masking", "");
                  formik.setFieldValue("nric", "");
                  formik.setFieldValue("nric_char", "");
                  formik.setFieldValue("fin_masking", "");
                  formik.setFieldValue("fin", "");
                  formik.setFieldValue("fin_char", "");
                  formik.setFieldValue("passport", "");
                }}
                onBlur={formik.handleBlur}
                value={formik.values.id_type}
                formik={formik}
                data={[
                  { name: "NRIC", value: "NRIC" },
                  { name: "FIN", value: "FIN" },
                  { name: "PASSPORT", value: "PASSPORT" },
                ]}
              />
            </div>
            <div className="col-md-4">
              {formik.values.id_type === "NRIC" && (
                <>
                  <div className="d-flex">
                    <p className="mb-1">NRIC(Example : S1234567T)</p>
                    <p className="erroStar">*</p>
                  </div>
                  <MaskingComponent
                    formik={formik}
                    placeholder={"Enter NRIC"}
                    masking_key={"nric_masking"}
                    real_key={"nric"}
                    char_key={"nric_char"}
                  />
                </>
              )}
              {formik.values.id_type === "FIN" && (
                <>
                  <div className="d-flex">
                    <p className="mb-1">FIN (Example : F1234567T)</p>
                    <p className="erroStar">*</p>
                  </div>
                  <MaskingComponent
                    formik={formik}
                    placeholder={"Enter FIN"}
                    masking_key={"fin_masking"}
                    real_key={"fin"}
                    char_key={"fin_char"}
                  />
                </>
              )}
              {formik.values.id_type === "PASSPORT" && (
                <>
                  <div className="col-md-12">
                    <div className="d-flex">
                      <p className="mb-1">Passport</p>
                      <p className="erroStar">*</p>
                    </div>
                    <CustomInput
                      type="text"
                      name="passport"
                      placeholder="Enter Passport No"
                      value={formik.values.passport}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      formik={formik}
                    />
                  </div>{" "}
                </>
              )}
            </div> */}
          </div>
          <div className="mt-2 cntr mb-2">
            <hr />
            <h6>{"ADDRESS DETAILS"}</h6>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex">
                <p className="mb-1">Address</p>
                <p className="erroStar">*</p>
              </div>
              <CustomInput
                type="text"
                name="address_detail.address"
                placeholder="Enter address"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_detail.address}
                formik={formik}
                errorMsg={
                  formik.touched.address_detail?.address &&
                  formik.errors?.address_detail?.address
                }
              />
            </div>
            <div className="col-md-6">
              <p className="mb-1">Country</p>
              <CustomSelect
                type="text"
                name="address_detail.country"
                placeholder="SELECT A COUNTRY"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_detail.country}
                formik={formik}
                data={CountryListResponse?.data?.map((e) => {
                  return {
                    ...e,
                    name: e?.name?.toUpperCase(),
                  };
                })}
              />
            </div>
            <div className="col-md-6">
              <p className="mb-1">State</p>
              <CustomSelect
                type="text"
                name="address_detail.state"
                placeholder="SELECT A STATE"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_detail.state}
                formik={formik}
                data={StatListResponse?.data?.map((e) => {
                  return {
                    ...e,
                    name: e?.name?.toUpperCase(),
                  };
                })}
              />
            </div>
            <div className="col-md-6">
              <p className="mb-1">City</p>
              <CustomInput
                type="text"
                name="address_detail.city"
                placeholder="Enter city"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_detail.city}
                formik={formik}
              />
            </div>{" "}
            <div className="col-md-6">
              <p className="mb-1">Zipcode</p>
              <CustomInput
                type="text"
                name="address_detail.zipcode"
                placeholder="Enter zipcode"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.address_detail.zipcode}
                formik={formik}
              />
            </div>
            <div className="col-md-6">
              <div className="d-flex">
                <p className="mb-1">Role</p>
                <p className="erroStar">*</p>
              </div>
              <CustomSelect
                type="text"
                name="role"
                placeholder="SELECT A ROLE"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.role}
                formik={formik}
                setValue={"_id"}
                data={getCustomRoleListResponse?.data?.filter(
                  (e) => e.status === "ACTIVE",
                )}
                errorMsg={formik.touched.role && formik.errors?.role}
              />
            </div>
          </div>

          <div className="mt-2 cntr mb-3">
            <hr />
            <h6>{"AUTHORIZATION DETAILS"}</h6>
          </div>

          <div className="row">
            <div className="col_md_6">
              <CustomCheckBox
                name="is_super_admin"
                value={formik.values.is_super_admin}
                onChange={formik.handleChange}
                checked={formik.values.is_super_admin}
                label="Is Super Admin (The highest role with full access to all system settings and permissions)"
              />
            </div>
          </div>

          {isSuperAdmin(getUserResponse?.data) && (
            <>
              <div className="mt-2 cntr mb-3">
                <hr />
                <h6>{"OTP DETAILS"}</h6>
              </div>
              <div className="row">
                <div className="col_md_6">
                  <CustomCheckBox
                    name="otp_feature"
                    value={formik.values.otp_feature}
                    onChange={formik.handleChange}
                    checked={formik.values.otp_feature}
                    label="Enable OTP Feature"
                  />
                </div>
              </div>
            </>
          )}

          <div className="btnActnBar">
            <CustomButton
              label={"Cancel"}
              btnType="secondary"
              onClick={() => handleClose()}
              action={"CANCEL"}
            />
            <CustomButton
              label={employeeData ? "Update" : "Save"}
              type="submit"
              action="SAVE"
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default AddEmployees;
